module.exports = __webpack_public_path__ + "3cb06a3dde2f4cb2549f05e75c49341e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/ES.svg
// module id = K2ZY
// module chunks = 0